import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import useRefreshOnReturn from "../lib/useRefreshOnReturn";

const FilterContext = createContext(null);

export const RANGES = [
  { value: "1d", label: "1D", period: "1d" },
  { value: "1w", label: "1W", period: "1w" },
  { value: "1m", label: "1M", period: "1m" },
  { value: "1y", label: "1Y", period: "1y" },
  { value: "5y", label: "5Y", period: "5y" },
  { value: "all", label: "All", period: "all" },
];

function rangeToDates(value) {
  const now = new Date();
  const start = new Date();
  switch (value) {
    case "1d": start.setDate(now.getDate() - 1); break;
    case "1w": start.setDate(now.getDate() - 7); break;
    case "1m": start.setMonth(now.getMonth() - 1); break;
    case "1y": start.setFullYear(now.getFullYear() - 1); break;
    case "5y": start.setFullYear(now.getFullYear() - 5); break;
    default: return { start: null, end: null };
  }
  return { start: start.toISOString(), end: now.toISOString() };
}

export function FilterProvider({ children }) {
  const [range, setRange] = useState("all");
  const [custom, setCustom] = useState({ start: "", end: "" });
  const dates = range === "custom"
    ? { start: custom.start ? new Date(custom.start).toISOString() : null, end: custom.end ? new Date(custom.end).toISOString() : null }
    : rangeToDates(range);
  const period = range === "custom" || range === "all" ? "all" : range;
  return (
    <FilterContext.Provider value={{ range, setRange, custom, setCustom, dates, period }}>
      {children}
    </FilterContext.Provider>
  );
}

export const useFilter = () => useContext(FilterContext);

// ---- Notifications hook (shared) ----
export function useNotifications() {
  const [items, setItems] = useState([]);
  const load = useCallback(async () => {
    try {
      const res = await api.notifications();
      setItems(res.data);
    } catch (e) {}
  }, []);
  useEffect(() => {
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, [load]);
  // Backgrounded tabs have their timers throttled or suspended, so the 60s poll
  // above cannot be relied on to have kept running while the app was away.
  useRefreshOnReturn(load, { minIdleMs: 10000 });
  const unread = items.filter((i) => !i.read).length;
  return { items, unread, reload: load };
}
